var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "60px",
    viewBox: "0 0 38 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "m") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.874924,59.9998569 C34.9803854,59.9998569 37.4999106,57.4803317 37.4999106,54.3748704 L37.4999106,5.62498659 C37.4999106,2.51952524 34.9803854,0 31.874924,0 L5.62498659,0 C2.51952524,0 0,2.51952524 0,5.62498659 L0,54.3748704 C0,57.4803317 2.51952524,59.9998569 5.62498659,59.9998569 L31.874924,59.9998569 Z M31.874924,56.2498659 L5.62498659,56.2498659 C4.59376194,56.2498659 3.74999106,55.406095 3.74999106,54.3748704 L3.74999106,5.62498659 C3.74999106,4.59376194 4.59376194,3.74999106 5.62498659,3.74999106 L31.874924,3.74999106 C32.9061487,3.74999106 33.7499195,4.59376194 33.7499195,5.62498659 L33.7499195,54.3748704 C33.7499195,55.406095 32.9061487,56.2498659 31.874924,56.2498659 Z M18.7499553,52.4998748 C20.824192,52.4998748 22.4999464,50.8241205 22.4999464,48.7498838 C22.4999464,46.6756471 20.824192,44.9998927 18.7499553,44.9998927 C16.6757186,44.9998927 14.9999642,46.6756471 14.9999642,48.7498838 C14.9999642,50.8241205 16.6757186,52.4998748 18.7499553,52.4998748 Z",
    id: "m",
    fill: "#00BCF5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.89ae909e9c55928b1fde80023b112003.svg";
export { ForwardRef as ReactComponent };